import { motion } from "framer-motion";
import { MaskLines } from "./Reveal";

export const PageHero = ({ kicker, title, image, height = "h-[70vh]" }) => (
  <section className={`relative ${height} min-h-[440px] flex items-center justify-center overflow-hidden bg-black`}>
    <motion.img
      src={image} alt={title}
      className="absolute inset-0 w-full h-full object-cover"
      initial={{ scale: 1.2 }} animate={{ scale: 1 }} transition={{ duration: 1.8, ease: [0.22, 1, 0.36, 1] }}
    />
    <div className="absolute inset-0 bg-black/55" />
    <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent" />
    <div className="relative z-10 text-center px-6 pt-16">
      <motion.p
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} transition={{ delay: 0.3, duration: 1 }}
        className="text-[10px] md:text-xs tracking-[0.45em] uppercase text-[#c5a059] mb-6"
      >
        {kicker}
      </motion.p>
      <h1 className="font-serif text-white font-light leading-[0.95] text-5xl sm:text-6xl md:text-7xl lg:text-8xl">
        <MaskLines lines={Array.isArray(title) ? title : [title]} delay={0.4} />
      </h1>
    </div>
  </section>
);
